import React, { useEffect, useState } from "react";
import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Typography,
    Box,
    TextField,
    Button,
    Chip,
    Stack,
} from "@mui/material";
import { getIOTSensors } from "../../api/api";

const SensorSelection = ({ selectedSensors, setSelectedSensors }) => {
    const [sensors, setSensors] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const fetchSensors = async () => {
            try {
                const response = await getIOTSensors();
                setSensors(response.data);
            } catch (error) {
                console.error("Error fetching sensors:", error);
            }
        };

        fetchSensors();
    }, []);

    const handleAdd = (sensor) => {
        setSelectedSensors((prev) => [...prev, sensor]);
    };

    const handleRemove = (index) => {
        setSelectedSensors((prev) => prev.filter((_, i) => i !== index));
    };

    const filteredSensors = sensors.filter((sensor) =>
        sensor.sensor_name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <Box>
            <Typography variant="h6">Select Sensors</Typography>
            <TextField
                label="Search Sensors"
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ mb: 2 }}
            />
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1">Selected Sensors:</Typography>
                <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", mt: 1 }}>
                    {selectedSensors.map((sensor, index) => (
                        <Chip
                            key={index}
                            label={`${sensor.sensor_name} (${index + 1})`}
                            onDelete={() => handleRemove(index)}
                            sx={{ mb: 1 }}
                        />
                    ))}
                </Stack>
            </Box>
            <Box
                sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    p: 1,
                }}
            >
                <List>
                    {filteredSensors.map((sensor) => (
                        <ListItem key={sensor._id} alignItems="flex-start">
                            <ListItemAvatar>
                                <Avatar src={sensor.imageUrl} alt={sensor.sensor_name} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={<Typography variant="subtitle1">{sensor.sensor_name}</Typography>}
                                secondary={
                                    <>
                                        <Typography variant="body2" color="textSecondary">
                                            {sensor.description}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            Use cases: {sensor.use_cases.join(", ")}
                                        </Typography>
                                    </>
                                }
                            />
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleAdd(sensor)}
                            >
                                Add
                            </Button>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Box>
    );
};

export default SensorSelection;
